import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchAgencyAuthoritiesFailure,
  fetchAgencyAuthoritiesRequest,
  fetchAgencyAuthoritiesSuccess,
} from 'redux/slice/agency-onbording/AgencyAuthorities.slice';
import { agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

const fetchAgencyAuthoritiesApi = async (agencyId: string) => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.GET_AGENCY_AUTHORITIES(agencyId)
  );
  return response.data;
};

function* fetchAgencyAuthoritiesSaga(action: any): Generator<any, void, any> {
  try {
    const allocators = yield call(fetchAgencyAuthoritiesApi, action.payload);
    yield put(fetchAgencyAuthoritiesSuccess(allocators));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to fetch allocators';
    yield put(fetchAgencyAuthoritiesFailure(errorMessage));
  }
}

export function* watchAgencyAuthoritiesSaga() {
  yield takeLatest(
    fetchAgencyAuthoritiesRequest.type,
    fetchAgencyAuthoritiesSaga
  );
}
